import WebSocketTypes from './websocket.types';
import { IWebSocketParameters } from '@missionlabs/smartagent-lib-shared';

export type WebSocketAction = {
    type: typeof WebSocketTypes.CREATE_WEBSOCKET_CONNECTION;
    payload: IWebSocketParameters;
};

export function createWebSocketConnection(webSocketParameters: IWebSocketParameters): WebSocketAction {
    return {
        type: WebSocketTypes.CREATE_WEBSOCKET_CONNECTION,
        payload: webSocketParameters,
    };
}
